import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { questionListReducer } from './reducers/questionReducers';
import { userAdminListReducer, userReducer } from './reducers/userReducers';
import {
  answerAdminListReducer,
  answerAdminLoadReducer,
  answerListReducer,
  answerReducer,
} from './reducers/answerReducer';

const reducer = combineReducers({
  questionsList: questionListReducer,
  user: userReducer,
  userAnswer: answerReducer,
  answerList: answerListReducer,
  answerAdminList: answerAdminListReducer,
  usersAdminList: userAdminListReducer,
  userAdminLoadAnswer: answerAdminLoadReducer,
});

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const answerFromStorage = localStorage.getItem('userAnswer')
  ? JSON.parse(localStorage.getItem('userAnswer'))
  : { answers: [] };

const initialState = {
  user: { userInfo: userInfoFromStorage },
  userAnswer: { answer: answerFromStorage },
  answerList: { answers: [] },
  answerAdminList: { answers: [] },
  usersAdminList: { users: [] },
  userAdminLoadAnswer: {},
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
